const merged = (state = false, action = {}) => {
  if (action.type === 'MERGED') {
    return !state
  } else {
    return state
  }
}

export default merged
